import React from 'react'

interface BodyProps {
  children: React.ReactNode;
}

export function Body ({ children }: BodyProps) {
  return (
    <div className='border-x last:border-b border-t border-gray-200 px-4 py-3 last:rounded-b-2xl first:rounded-t-2xl flex flex-col gap-2 grow'>
      {children}
    </div>
  )
}

Body.displayName = 'MarketplaceCard.Body'
